class $f998f54f9c29d882$export$a2a4245643e0242b extends HTMLElement {
    connectedCallback() {
        const label = this.getAttribute("label") || "";
        const note = this.getAttribute("note") || "";
        const href = this.getAttribute("href") || "#";
        const customActions = Array.from(this.querySelectorAll("a[href]")).map((action)=>({
                href: action.href,
                label: action.textContent?.trim() || "Open"
            }));
        const card = document.createElement("div");
        card.className = "link-anchor";
        const content = document.createElement("div");
        content.className = "link-content";
        const title = document.createElement("span");
        title.className = "link-label";
        title.textContent = label;
        const subtitle = document.createElement("span");
        subtitle.className = "link-note";
        subtitle.textContent = note;
        content.append(title, subtitle);
        const actions = document.createElement("div");
        actions.className = "link-actions";
        actions.append($f998f54f9c29d882$var$createAction(href, "Open"));
        for (const action of customActions)actions.append($f998f54f9c29d882$var$createAction(action.href, action.label));
        card.append(content, actions);
        this.replaceChildren(card);
    }
}
function $f998f54f9c29d882$var$createAction(href, label) {
    const action = document.createElement("a");
    action.href = href;
    action.target = "_blank";
    action.rel = "noreferrer noopener";
    action.className = "link-arrow";
    action.textContent = label;
    return action;
}
customElements.define("profile-link", $f998f54f9c29d882$export$a2a4245643e0242b);


const $62b0c594a7478793$var$STAR_CACHE_KEY = "github-repo-stars-v1";
const $62b0c594a7478793$var$STAR_CACHE_TTL_MS = 1800000;
async function $62b0c594a7478793$export$10b6c4f736b65d82(links) {
    const cache = $62b0c594a7478793$var$readStarCache();
    await Promise.all(links.map(async (link)=>{
        const repo = link.getAttribute("data-github-repo");
        if (!repo) return;
        const baseNote = link.getAttribute("note") || "";
        const cached = cache[repo];
        if (cached && Date.now() - cached.fetchedAt < $62b0c594a7478793$var$STAR_CACHE_TTL_MS) {
            $62b0c594a7478793$var$setStarNote(link, baseNote, cached.stars);
            return;
        }
        try {
            const response = await fetch(`https://api.github.com/repos/${repo}`, {
                headers: {
                    Accept: "application/vnd.github+json"
                }
            });
            if (!response.ok) return;
            const payload = await response.json();
            if (typeof payload.stargazers_count !== "number") return;
            const count = payload.stargazers_count;
            cache[repo] = {
                stars: count,
                fetchedAt: Date.now()
            };
            $62b0c594a7478793$var$writeStarCache(cache);
            $62b0c594a7478793$var$setStarNote(link, baseNote, count);
        } catch  {
        // Keep the original note text if GitHub is unavailable or rate-limited.
        }
    }));
}
function $62b0c594a7478793$var$setStarNote(link, baseNote, stars) {
    const starText = `${stars.toLocaleString()} ${stars === 1 ? "star" : "stars"}`;
    const nextNote = baseNote ? `${baseNote} | ${starText}` : starText;
    const noteElement = link.querySelector(".link-note");
    if (noteElement) noteElement.textContent = nextNote;
}
function $62b0c594a7478793$var$readStarCache() {
    try {
        const raw = window.localStorage.getItem($62b0c594a7478793$var$STAR_CACHE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch  {
        return {};
    }
}
function $62b0c594a7478793$var$writeStarCache(cache) {
    try {
        window.localStorage.setItem($62b0c594a7478793$var$STAR_CACHE_KEY, JSON.stringify(cache));
    } catch  {
    // Ignore localStorage failures and continue without caching.
    }
}


const $b168e4b48d085655$var$heroImage = document.querySelector(".full-bleed-bg");
if ($b168e4b48d085655$var$heroImage) {
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                $b168e4b48d085655$var$heroImage.classList.add("visible");
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15
    });
    observer.observe($b168e4b48d085655$var$heroImage);
}



const $ad2bcec7a0192558$var$year = document.getElementById("year");
if ($ad2bcec7a0192558$var$year) $ad2bcec7a0192558$var$year.textContent = String(new Date().getFullYear());
const $ad2bcec7a0192558$var$projectLinks = Array.from(document.querySelectorAll("profile-link[data-github-repo]"));
(0, $62b0c594a7478793$export$10b6c4f736b65d82)($ad2bcec7a0192558$var$projectLinks);


//# sourceMappingURL=app.6e0b18ab.js.map
